import { ReactComponent as UaFlag } from '../../assets/icons/flags/ua.svg'
import { ReactComponent as UkFlag } from '../../assets/icons/flags/flag-uk.svg'

export const LANGUAGE_VALUE = {
  UA: 'ua',
  EN: 'en'
}

export const languagesList = [
  {
    value: LANGUAGE_VALUE.EN,
    label: 'English',
    icon: UkFlag
  },
  {
    value: LANGUAGE_VALUE.UA,
    label: 'Українська',
    icon: UaFlag
  }
]

export const tikTokLanguagesList = [
  { label: 'Arabic', value: 'ar' },
  { label: 'Assamese', value: 'as' },
  { label: 'Bengali', value: 'bn' },
  { label: 'Bhojpuri', value: 'bh' },
  { label: 'Chinese (Traditional)', value: 'zh-Hant' },
  { label: 'Czech', value: 'cs' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English', value: LANGUAGE_VALUE.EN },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'German', value: 'de' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Haryanvi', value: 'bgc' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Kannada', value: 'kn' },
  { label: 'Korean', value: 'ko' },
  { label: 'Malay', value: 'ms' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Oriya', value: 'or' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Punjabi', value: 'pa' },
  { label: 'Rajasthani', value: 'raj' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Spanish', value: 'es' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Telugu', value: 'te' },
  { label: 'Thai', value: 'th' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Vietnamese', value: 'vi' }
]
